export const API_FEEDBACK_URL =
    process.env.REACT_APP_API_FEEDBACK_URL || "http://localhost:8080"
